import React from 'react';
import { Button, MessageBox, MessageBoxType, Text } from '@ui5/webcomponents-react';
import { useTranslations } from '@/hooks/useTranslations';

interface WarningMessageBoxProps {
    open: boolean;
    dataTestId?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const WarningMessageBox: React.FC<WarningMessageBoxProps> = ({ open, dataTestId, onConfirm, onCancel }) => {
    const { t } = useTranslations();
    return (
        <MessageBox
            open={open}
            type={MessageBoxType.Warning}
            onClose={onCancel}
            data-testId={dataTestId}
            actions={[
                <Button design="Emphasized" key="okButton" data-testid="okButton" onClick={onConfirm}>
                    {t('OK_BUTTON')}
                </Button>,
                <Button design="Transparent" key="cancelButton" data-testid="cancelButton" onClick={onCancel}>
                    {t('CANCEL_BUTTON')}
                </Button>,
            ]}
        >
            <Text>{t('UNSAVED_DATA_LOST')}</Text>
            <br />
            <Text>{t('POPUP_ACTIONS_MESSAGE')}</Text>
            <br />
            <Text>{t('TO_SAVE_DATA')}</Text>
        </MessageBox>
    );
};

export default WarningMessageBox;